'use client';

/**
 * MetadataSection — semantic_id footer for rail cards.
 *
 * Mode4-native parallel of `<MetadataSection />` under
 * copilot/details/sections/. Tiny footer showing the SID in mono
 * font for ops debugging.
 *
 * @layer presentation
 * @arch_component_type section
 * @arch_domain copilot / rail-insights
 */

import { Hash } from 'lucide-react';

interface MetadataSectionProps {
  semanticId: string | null | undefined;
}

export function MetadataSection({ semanticId }: MetadataSectionProps) {
  if (!semanticId) return null;
  return (
    <div className="pt-2 border-t border-border/30">
      <div className="flex items-center gap-1.5">
        <Hash className="h-3 w-3 text-muted-foreground/60 shrink-0" />
        <code className="text-[10px] font-mono text-muted-foreground/60 truncate">
          {semanticId}
        </code>
      </div>
    </div>
  );
}
